import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from '../contexts/Language';

export const Modal = props => {
  const { Show, Title, children, Status, onClose, onPending } = props;
  return (Show ?
    (
      <>
        <div className="modal fade bs-example-modal-lg show d-block fadeIn" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title mt-0" id="myLargeModalLabel">{Title}</h5>
                <button type="button" className="close" data-dismiss="modal" onClick={onClose} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {children}
              </div>
              <div className="modal-footer">
                {
                  props.Withdraw && (Status === 'Cancel' || Status === 'Confirm') ?
                    <button type="button" className="btn btn-warning waves-effect" onClick={onPending} data-dismiss="modal">{Translate('Set Pending')}</button>
                    : ''
                }
                {
                  props.Deposit && (props.Status === 'Temp' || props.Status === 'Manual') &&
                  <button type="button" className="btn btn-warning waves-effect" onClick={props.onSetStatus} data-dismiss="modal">{Translate("Set Status for Confirm")}</button>
                }
                <button type="button" className="btn btn-secondary waves-effect" onClick={onClose} data-dismiss="modal">{Translate('Close')}</button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" />
      </>
    ) : ''
  );
};

Modal.propTypes = {
  Show: PropTypes.bool.isRequired,
  Title: PropTypes.array,
  children: PropTypes.node.isRequired,
  Status: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onPending: PropTypes.func,
};

Modal.defaultProps = {
  Title: null,
  Status: null,
  onPending: null,
};
